import { RESET_STATE } from "./actionTypes";

export const resetState = () => ({
  type: RESET_STATE,
});
